<template>
   <ModalWrapper center @close="$emit('close')" :open="open">
      <template #header>
         <h3>Create Class</h3>
         <p class="serif grey">Use a unique name to create your class</p>
      </template>
      <template #body>
         <FormGenerator
            id="create-class-form"
            :schema="schema"
            @submit="handleSubmit"
         />
      </template>
      <template #footer>
         <Btn textLink text="Cancel" action @handleAction="$emit('close')" />
         <Btn
            buttonType="success"
            action
            text="Create Class"
            @handleAction="handleClick"
         />
      </template>
   </ModalWrapper>
</template>

<script setup lang="ts">
import * as Yup from "yup";
const emit = defineEmits(["close"]);
const classesStore = useClassesStore();

const props = defineProps({
   open: { type: Boolean, required: true, default: false },
});

// >> Filtering of the Standards
const schema = reactive({
   fields: [
      {
         label: "Title",
         name: "title",
         as: "input",
         type: "text",
         rules: Yup.string().required(),
      },
   ],
});

// Form Submit
const callHook = useNuxtApp().callHook;
// >> Methods
const handleClick = () => {
   callHook("form:submit", "create-class-form");
};
const handleSubmit = async (formData) => {
   const data = await classesStore.createClass(formData);
   await navigateTo({
      name: "class",
      params: { slug: data?.slug },
   });
};
</script>
